// extracted by mini-css-extract-plugin
export default {"form__field":"solve-issue-form_form__field__oG08k","form__title":"solve-issue-form_form__title__xUL4t"};